import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingRight: '50px',
      [theme && theme.breakpoints.down('sm')]: {
        paddingRight: '0px',
        marginLeft: '-51px !important'
      }
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: '#ffffff',
      color: theme.palette.secondary.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.grey[300],
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2)
      }
    },
    logo: {
      width: `${theme.logo.width}px`,
      height: `${theme.logo.height}px`,
      backgroundImage: `url(${theme.logo.base64})`,
      backgroundSize: `${theme.logo.width}px ${theme.logo.height}px`
    }
  });
